<template>
  <div class="container">
    <div class="navi">
        <router-link to="/">
          <span class="icon-arrow-left"></span>
        </router-link>
    </div>
    <div class="title">请选择搬家车型</div>

  </div>
</template>

<script>
export default {
  name: 'changeme',
  data () {
    return {
      order:{}
    }
  },
  methods: {
    changeDate(){
      this.order.temp.isDate=true;
    }
  },
  components: {
  },
  mounted: function () {
    if (localStorage.order) {
      this.order = JSON.parse(localStorage.order);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";


</style>



// WEBPACK FOOTER //
// src/pages/baggage/template.vue